import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import * as moment from 'moment';
import {NbFieldType} from "./nbinput.entity";

@Component({
  selector: 'nbinput-date',
  template: require('./nbinput-date.component.html'),
  styles: [require('./nbinput-date.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputDateComponent),
      multi: true
    }
  ]
})

export class NbinputDateComponent implements ControlValueAccessor {
  public FieldType = NbFieldType;
  config:any = {
    format: 'YYYY-MM-DD',
    monthFormat: 'YYYY-MM',
    showMultipleYearsNavigation: true,
    locale: moment.locale('zh-cn'),
  };

  calType = {
    'date':'day',
    'datetime':'daytime',
    'time':'time',
    'month':'month',
  };

  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};

  @Input()
  // public data;
  public data;
  @Input()
  public disabled;

  get value(): any {
    return this.data;
  };
  set value(v: any) {
    if (v !== this.data) {
      this.data = v;
      this.onChangeCallback(v);
    }
  }

  //Set touched on blur
  onBlur() {
    this.onTouchedCallback();
  }

  @Input()
  public placeholder = '点击选择时间';

  @Input()
  public type: NbFieldType = NbFieldType.Date;
  @Input()
  public readonly = false;

  registerOnChange(fn: any): void {this.onChangeCallback = fn;}
  registerOnTouched(fn: any): void {this.onTouchedCallback = fn;}
  setDisabledState?(isDisabled: boolean): void { this.disabled = isDisabled; }
  writeValue(obj): void {
    if (obj){
      // console.log('data: ',obj);
      let val = moment(obj);
      if (val.isValid()){
        this.data = this.setDateFormat(val);
      }
    }
  }
  setDateFormat(val){
    switch (this.type) {
      case NbFieldType.Date: {
        return val.format("YYYY-MM-DD");
      }
      case NbFieldType.Datetime: {
        return val;
      }
      case NbFieldType.Month: {
        return val.format("YYYY-MM");
      }
      case NbFieldType.Time: {
        return val.format("hh:mm:ss");
      }
    }
  }
  onChange(evt) {
    if (evt) {
      // this.data = this.setDateFormat(evt);
      this.onChangeCallback(evt.format("YYYY-MM-DDTHH:mm:ss.SSSZZ"));
    }
  }
}




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/nbinput/nbinput-date.component.ts